import { accessHeaders, withAccessQuery } from './sessionAccess.js';

// Accès lecteur : linkkey en v1, jeton en en-tête en v2 (voir sessionAccess.js).
// Le paramètre `linkkey` des fonctions reste pour la compatibilité des appels.
const sessionApiUrl = (backendApiUrl, sessionId, resource) => {
    const baseUrl = backendApiUrl.replace(/\/+$/, '');
    return withAccessQuery(`${baseUrl}/api/session/${encodeURIComponent(sessionId)}/${resource}`);
};

export async function fetchSessionHistory(backendApiUrl, sessionId) {
    const response = await fetch(
        sessionApiUrl(backendApiUrl, sessionId, 'historyEvent'),
        { cache: 'no-store', headers: await accessHeaders() }
    );
    if (!response.ok) throw new Error(`Historique de session indisponible (${response.status})`);
    return await response.json();
}

export async function fetchInitialState(backendApiUrl, sessionId) {
    const response = await fetch(sessionApiUrl(backendApiUrl, sessionId, 'initial-state'), { headers: await accessHeaders() });
    if (!response.ok) throw new Error(`État initial de session indisponible (${response.status})`);
    return await response.json();
}

export async function fetchRealtimeCredentials(backendApiUrl, sessionId) {
    const response = await fetch(
        sessionApiUrl(backendApiUrl, sessionId, 'realtime-credentials'),
        { cache: 'no-store', headers: await accessHeaders() }
    );
    if (!response.ok) throw new Error(`Temps réel de session indisponible (${response.status})`);
    return await response.json();
}

export { isAlertSessionType, getAlertMediaType } from './sessionTypes.js';
